import { ClassNameProps } from "@/types";

/**
 * Defines the visual styles available for the core badge component.
 */
enum CoreBadgeVariant {
  White = "white",
  Black = "black",
  Live = "live",
  LiveNotification = "live-notification",
  Brand = "brand",
  Contextual = "contextual",
  TuneIn = "tuneIn",
  TuneInBanner34 = "tune-in-banner-34",
}

/**
 * The sizes available for the core badge component.
 */
enum CoreBadgeSize {
  Size40 = "40",
  Size32 = "32",
  Size24 = "24",
  Size20 = "20",
  Size16 = "16",
  Size8 = "8",
}

interface CoreBadgeProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  variant?: CoreBadgeVariant;
  size?: CoreBadgeSize;
}

export { CoreBadgeVariant, CoreBadgeSize };
export type { CoreBadgeProps };
